import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { signIn, getSession } from "next-auth/react";
import toast from "react-hot-toast";

const initialState = {
  user: null,
  token: null,
};

export const loginWithGoogle = createAsyncThunk(
  "authSlice/loginWithGoogle",
  async ({ toastId }, { rejectWithValue, dispatch }) => {
    try {
      const data = await signIn("google", { callbackUrl: "/" });

      if (data?.error) {
        toast.error(data.error);
        return rejectWithValue(data.error);
      }

      // ✅ ye session me `user` + `token` aa jayega
      const session = await getSession();

      if (session) {
        dispatch(setUser({ user: session.user, token: session.accessToken }));
        localStorage.setItem('accessToken', session?.accessToken)
      }

      toast.success("Login successful!", { id: toastId, duration: 2000 });
      return session;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(loginWithGoogle.fulfilled, (state, action) => {
        console.log(action.payload, 'action.payload from builder')
        state.user = action.payload.user;
        state.token = action.payload.accessToken
      })
  },
  reducers: {
    setUser: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentUser = (state) => state.auth.user;

export const { setUser, logout } = authSlice.actions;
export default authSlice.reducer;

